export default "__VITE_ASSET__DsaK0P0p__"